import React from 'react';
import { SecondaryButton, PrimaryButton, Modal, Pulse } from 'wf-react-component-library';
import currencyFormatter from '../utilities/currency-formatter';

import './DeleteConfirmationModal.scss';

class DeleteConfirmationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDeleting: false
        };

        this.handleDelete = this.handleDelete.bind(this);
    }

    handleDelete = (e) => {
        this.setState({
            isDeleting: true
        });

        this.props.deleteItems(e);
    }

    render () {
        const { isDeleting } = this.state;

        return (
            <Modal show={true} width="75%">
                <div className="flex-container-row item-details-container show">
                    <div className="flex-container-row top-level">
                        <div className="headline-small fixed-divider">Are you sure you want to delete the following items:  </div>
                    </div>

                    <div className="flex-container-row deleted-items">
                        <table className="deleted-items" cellPadding="0" cellSpacing="0" width="100%">
                            <colgroup>
                                <col span="1" style={{ width: '8%' }} />
                                <col span="1" style={{ width: '40%' }} />
                            </colgroup>

                            <tbody>
                                <tr className="deleted-items-table-header">
                                    <td>Item Id</td>
                                    <td>Description</td>
                                    <td>Cost</td>
                                    <td>Location</td>
                                    <td>Country Of Origin</td>
                                </tr>

                                { this.props.selectedItems.map(item => 
                                    <tr key={item.vendorItemId} className="item-row">
                                        <td>
                                            <span className="body-short-form">{item.itemId}</span>
                                        </td>
                                        <td>
                                            <span className="body-short-form">{item.description}</span>
                                        </td>
                                        <td>
                                            <span className="body-short-form">{item.cost > 0 ? currencyFormatter.format(item.cost) : item.cost}</span>
                                        </td>
                                        <td>
                                            <span className="body-short-form">{item.location}</span>
                                        </td>
                                        <td>
                                            <span className="body-short-form">{item.countryOfOrigin}</span>
                                        </td>
                                    </tr>
                                )}

                            </tbody>
                        </table>
                    </div>
                    
                    { isDeleting 
                    ? <Pulse text='Deleting Items...' />
                    : (                        
                        <div className="flex-container-row buttons">
                            <PrimaryButton onClick={(e) => this.handleDelete(e)} name="Delete" />
                            <SecondaryButton onClick={this.props.closeModal} name="Cancel" />
                        </div>
                    )}
                </div>
            </Modal>
    )};
}

export default DeleteConfirmationModal;
